import { ColGroupDef } from "ag-grid-community";

import {
  BusinessAddressColId,
  BusinessAddressGroupDef,
  BusinessColId,
  BusinessColumnDef,
} from "constants/columnDefinitions/business";

import { filterColIdsFromColumnDef } from "lib/agGrid";

export const BusinessGroupColId = {
  BUSINESS_GROUP: "d80c56f9-53b0-48d2-8c1b-ac981da93cc8",
} as const;

/**
 * "Business" column group for the Billing Run wizard grids (Review/Send/
 * Export), reused as-is across all three so they stay in sync by
 * construction. Surfaces the full Business record - not a hand-picked
 * subset - the same way Money Table's own "Business" group does (see
 * components/MoneyTable/columnDefinitions.js): every field on
 * `BusinessColumnDef` (minus Actions) plus the existing Address group, with
 * their default labels unchanged. Every row on these grids/tables already
 * carries a resolved `.business` object (see
 * selectors/aggrid/billingDocuments.js), so no new selector plumbing is
 * required - any field added to `BusinessColumnDef` in future shows up here
 * automatically.
 */
export const BusinessColumnGroup: ColGroupDef = {
  groupId: BusinessGroupColId.BUSINESS_GROUP,
  headerName: "Business",
  children: [
    ...filterColIdsFromColumnDef(BusinessColumnDef, [BusinessColId.ACTIONS]),
    BusinessAddressGroupDef[BusinessAddressColId.ADDRESS_GROUP],
  ],
};
